var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color_box"},[_c('span',[_vm._v("主题色")]),_c('el-color-picker',{staticClass:"theme-picker",attrs:{"size":"mini","popper-class":"theme-picker-dropdown"},model:{value:(_vm.themeVal),callback:function ($$v) {_vm.themeVal=$$v},expression:"themeVal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }